import React, { useState } from "react";
import styles from "./styles_plants.module.css";

interface PlantsData {
  key: number;
  region: string;
  counts: Record<string, string>;
}

const regions = [
  "Чуйская",
  "Ошская",
  "Нарынская",
  "Баткенская",
  "Таласская",
  "Иссык-Кульская",
  "Джалал-Абадская",
] as const;

const plants = ["Зерно", "Хлопок", "Табак", "Картофель", "Овощи", "Бахчи", "Плод. Культуры", "Виноград"] as const;

const dataSource: PlantsData[] = [
  {
    key: 0,
    region: "Чуйская",
    counts: {
      'Зерно': '527420',
      'Хлопок': '-',
      'Табак': '-',
      'Картофель': '86609',
      'Овощи': '265612',
      'Бахчи': '64831',
      'Плод. Культуры': '7443',
      'Виноград': '245',
    },
  },
  {
    key: 1,
    region: "Баткенская",
    counts: {
      'Зерно': '38745',
      'Хлопок': '21',
      'Табак': '224',
      'Картофель': '24795',
      'Овощи': '51193',
      'Бахчи': '1506',
      'Плод. Культуры': '42845',
      'Виноград': '1272',
    },
  },
  {
    key: 2,
    region: "Джалал Абадская",
    counts: {
      'Зерно': '165729',
      'Хлопок': '41321',
      'Табак': '-',
      'Картофель': '62115',
      'Овощи': '2150070',
      'Бахчи': '88523',
      'Плод. Культуры': '30485',
      'Виноград': '599',
    },
  },
  {
    key: 3,
    region: "Нарынская ",
    counts: {
      'Зерно': '18626',
      'Хлопок': '-',
      'Табак': '-',
      'Картофель': '51552',
      'Овощи': '1177',
      'Бахчи': '-',
      'Плод. Культуры': '45',
      'Виноград': '-',
    },
  },
  {
    key: 4,
    region: "Ошская ",
    counts: {
      'Зерно': '142944',
      'Хлопок': '33352',
      'Табак': '925',
      'Картофель': '95814',
      'Овощи': '130731',
      'Бахчи': '42321',
      'Плод. Культуры': '42663',
      'Виноград': '2345',
    },
  },
  {
    key: 5,
    region: "Таласская",
    counts: {
      'Зерно': '29418',
      'Хлопок': '-',
      'Табак': '-',
      'Картофель': '123417',
      'Овощи': '65102',
      'Бахчи': '1576',
      'Плод. Культуры': '15323',
      'Виноград': '15',
    },
  },
  {
    key: 6,
    region: "Иссык-Кульская",
    counts: {
      'Зерно': '108265',
      'Хлопок': '-',
      'Табак': '-',
      'Картофель': '301067',
      'Овощи': '18144',
      'Бахчи': '-',
      'Плод. Культуры': '50785',
      'Виноград': '-',
    },
  },

];

export const PlantsTable: React.FC = () => {
  const [selectedPlants, setSelectedPlants] = useState<typeof plants[number]>(
    plants[0]
  );

  const handlePlantsChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedPlants(event.target.value as typeof plants[number]);
  };

  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        <h2>Данные по областям (тонн)</h2>
        <select
          value={selectedPlants}
          onChange={handlePlantsChange}
          className={styles.select}
        >
          {plants.map((plant) => (
            <option key={plant} value={plant}>
              {plant}
            </option>
          ))}
        </select>

        <ul className={styles.table}>
          <li className={styles.header}>
            <span className={styles.cell}>Область</span>
            <span className={styles.cell}>{selectedPlants}</span>
          </li>
          {dataSource.map((item) => (
            <li key={item.key} className={styles.row}>
              <span className={styles.cell}>{item.region}</span>
              <span className={styles.cell}>
                {item.counts[selectedPlants] || 'Нет данных'}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

